export default {
    reset: "Reset your password",
    remembered: "Remembered it?",
};
